import React, { useState } from "react";
import { useSelector } from "react-redux";

// Slice

// Components
import PropTypes from 'prop-types';
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import ChartContainer from "../../../../app/common-components/ChartContainer.jsx";
import CustomModal from "../../../../app/common-components/CustomModal";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges";
import "../../../../app/common-components/DrillDown/features.common.styles.scss";
import Input from "../../../../app/common-components/form/input";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData";
import CommonBtn from "../../../../app/common-components/ui-components/Button/Index.jsx";

// Assets
import { deletedIcon } from "../../../../assets/images";

// Helpers

// Styles
import { get } from "lodash";
import "../styles.scss";
import { FiTrash2 } from "react-icons/fi";
import { getSortingValues } from "../../../../app/Constants.js";


const PIIConfigComponent = (props) => {
    const [state, setState] = useState({
        regexAddBodyOpen: false,
        regexmodalOpen: false,
        modalHide: false,
        whitelistAddBodyOpen: false,
        deleteIdRegex: [],
        deleteIdWhitelisted: [],
        dataInputState: false,
        typeInputState: false,
        expressionInputState: false,
        hierarchyLevelInputState: false,
        addBodyregex: false,
        addBodywhitelist: false,
    });

    const { regexCustomizationTableData, regexCustomizationDataCount, rCTableLoading, rCTableCountLoading, WhitelistedTableData, WhitelistedTableCount, WhitelistedLoading, RegexDeleteLoading, WhitelistedTableCountLoading, WhiteListSaveLoading, RegexStatusLoading, RegexSaveLoading, WhiteListDeleteLoading } = useSelector((state) => state.PIIConfigurationSlice);
    //PII regex Table  
    const regexPageLimit = get(props, 'data.regexPageLimit', 10);
    const regexPageSearch = get(props, 'data.regexPageSearch', '');
    const regexPageNo = get(props, 'data.regexPageNo', 10);
    const calculatedPageCount = regexCustomizationTableData?.totalCount ? Math.ceil(regexCustomizationTableData?.totalCount / regexPageLimit) : 0;
    const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;

    const [type, setType] = useState(props?.data?.type || '');
    const [expression, setExpression] = useState(props?.data?.expression || '');
    const [hierarchyLevel, setHierarchyLevel] = useState(props?.data?.hierarchyLevel || '');
    //PII whitelist Table
    const PIIPageLimit = get(props, 'data.PIIPageLimit', 10);
    const PIIPageSearch = get(props, 'data.PIIPageSearch', '');
    const PIIPageNo = get(props, 'data.PIIPageNo', 10);
    const PIIcalculatedPageCount = regexCustomizationTableData?.totalCount ? Math.ceil(WhitelistedTableCount / PIIPageLimit) : 0;
    const PIIfinalPageCount = calculatedPageCount !== 0 ? PIIcalculatedPageCount : 1;
    const { userName, userRole } = useSelector((state) => state.common.loggedUser);
    const notAllowedRoles = ["Application Manager", "Department Head", "Division Head"];
    const userAccess = !userRole.some(role => notAllowedRoles.includes(role));
    const [data, setData] = useState('');
    const [dataerrorMessage, setDataErrorMessage] = useState('');
    const [typeerrorMessage, setTypeErrorMessage] = useState('');
    const [isDuplicateAdded, setIsDuplicateAdded] = useState(false);
    const [expressionerrorMessage, setExpressionErrorMessage] = useState('');
    const [hierarchyLevelerrorMessage, setHierarchyLevelErrorMessage] = useState('');

    const handleDelete = (id) => {
        setState((state) => ({
            ...state,
            regexmodalOpen: true,
            deleteIdRegex: id,
        }));
    };
    const changeRegexStatus = (id, status) => {
        props.changeRegexStatus(id, status);
    };

    const regexColumns = [
        {
            Header: 'Type',
            accessor: 'type',
        },
        {
            Header: 'Expression',
            accessor: 'expression',
            Cell: (row) => {
                return (
                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {row.row.original.expression}
                    </div>
                );
            },
        },
        {
            Header: 'Hierarchy Level',
            accessor: 'hierarchyLevel',
            tdClassName: 'text-center',
        },
        {
            Header: 'Regex Status',
            accessor: 'status',
            thClassName: "text-center",
            Cell: (row) => {
                return (
                    <label className="toggle-control">
                        <input
                            type="checkbox"
                            className="switchInput"
                            id="switchInput_0"
                            checked={row.row.original.status === "Active" || row.row.original.status === "ACTIVE"}
                            onChange={() => { if (userAccess) { changeRegexStatus(row.row.original.id, row.row.original.status === "ACTIVE" || row.row.original.status === "Active" ? "Inactive" : "Active"); } }}
                        />
                        <span className="control"
                        data-testid="toggleControl"></span>
                    </label>
                );
            },
        },
        {
            Header: 'Action',
            accessor: 'actions',
            thClassName: 'text-center',
            tdClassName: 'text-center',
            disableSortBy: true,
            Cell: ({ row }) => (
                <div className="actcol fs-5">
                    <FiTrash2
                        title="Delete"
                        data-testid={"deleteIcon"}
                        className="iconStyleActions"
                        onClick={() => { if (userAccess) { handleDelete(row.original.id); } }}
                    />
                </div>
            )
        },
    ];

    const handleRegexAdd = async () => {
        setState((state) => ({
            ...state,
            regexAddBodyOpen: true,
            conformationPop: false
        }));
        setExpression("");
        setType("");
        setHierarchyLevel("");
    };

    const btnData = [
        {
            text: "Add",
            btnClassName: "CloudBudgetNewPosition mr-0",
            btnComponent: (
                <>
                    <CommonBtn
                        name="Add New"
                        clickFunc={() => handleRegexAdd()}
                        btnStyle="icon-btn"
                        disabled={!userAccess}
                    />
                </>
            ),
        },
    ];


    // PII Regex Table
    const handleRegexPageLimitChange = (limit) => {
        props.handleRegexPageLimitChange(limit);
    };

    const handleRegexSearch = (value) => {
        props.handleRegexSearch(value);
    };

    const handleRegexPageChange = (No) => {
        props.handleRegexPageChange(No);
    };
    const handleOnSorting = (column, headerSortingState) => {
        const { sortingField, isDataSorted } = getSortingValues(regexColumns, column, headerSortingState);
        props?.handleOnSorting(sortingField, isDataSorted);
    };

    // PII Whitelist Table

    const tableData = [
        {
            key: 1,
            title: 'Regex Customization',
            chart: () => {
                return rCTableCountLoading === true || rCTableLoading === true || RegexStatusLoading === true || RegexDeleteLoading === true ? (
                    <Spinners />
                ) : (
                    <>
                        <CompleteTableData
                            columns={regexColumns}
                            data={regexCustomizationTableData?.data || []}
                            listCount={regexCustomizationTableData?.totalCount}
                            pageLimit={regexPageLimit}
                            curentPageNumber={regexPageNo}
                            totalPageCount={finalPageCount}
                            btnData={btnData}
                            searchKey={regexPageSearch}
                            onPageLimitChange={handleRegexPageLimitChange}
                            onSearch={handleRegexSearch}
                            onPageNoChange={handleRegexPageChange}
                            onSorting={handleOnSorting}
                            headerSortingState={props.headerSortingState}
                            moveSearchToEnd={true}
                        />
                    </>
                );
            },
            navContainerClass: 'flowdisnav',
            chartContainerClass: 'flowdistribution svg-container',
            customClass: 'col-lg-12 col-md-12 order-md-12 order-lg-12 filtercol filetotal',
        },
        // {
        //     key: 2,
        //     title: 'PII Data: Whitelisted',
        //     chart: () => {
        //         return WhitelistedLoading === true || WhitelistedTableCountLoading === true || WhiteListSaveLoading === true ? (
        //             <Spinners />
        //         ) : (
        //             <>
        //                 <CompleteTableData
        //                     columns={piiColumns}
        //                     data={WhitelistedTableData}
        //                     listCount={WhitelistedTableCount}
        //                     pageLimit={PIIPageLimit}
        //                     curentPageNumber={PIIPageNo}
        //                     totalPageCount={PIIfinalPageCount}
        //                     searchKey={PIIPageSearch}
        //                     btnData={btnDataPII}
        //                     onPageLimitChange={handlePIIPageLimitChange}
        //                     onSearch={handlePIISearch}
        //                     onPageNoChange={handlePIIPageChange}
        //                     moveSearchToEnd={true}
        //                 />
        //             </>
        //         );
        //     },
        //     navContainerClass: 'flowdisnav',
        //     chartContainerClass: 'flowdistribution svg-container',
        //     customClass: 'col-lg-12 col-md-12 order-md-12 order-lg-12 filtercol filetotal',
        // },
    ];

    // Regex Delete popup
    const modalHide = () => {
        setState((state) => ({
            ...state,
            regexmodalOpen: false,
        }));
    };

    const handledeleteRegex = () => {
        props.handleRegexDelete(state.deleteIdRegex);
        setState((state) => ({
            ...state,
            regexmodalOpen: false,
            deleteIdRegex: [],
        }));
    };

    const renderModalBody = () => {
        return (
            <>
                <h4>PII Data Configuration</h4>
                {RegexDeleteLoading ? <Spinners /> : (<div>
                    <p>Are you sure you would like to delete this PII Data Configuration</p>
                    <div className="btnswrap">
                        <a className="cancelBtnStyle btn btn-primary"
                            onClick={modalHide}>
                            Cancel
                        </a>
                        <a className="btnStyle btn btn-primary" onClick={handledeleteRegex}>
                            Delete
                        </a>
                    </div>
                </div>)}
            </>
        );
    };

    // Whitelist Delete popup
    const whitelistHide = () => {
        setState((state) => ({
            ...state,
            whitelistmodalOpen: false,
        }));
    };

    const handleWhitelistedDelete = () => {
        props.handleWhitelistedDelete(state.deleteIdWhitelisted);
        setState((state) => ({
            ...state,
            whitelistmodalOpen: false,
            deleteIdWhitelisted: [],
        }));
    };

    const whitelistBody = () => {
        return (
            <>
                <h4>PII Data: Whitelisted</h4>
                {WhiteListDeleteLoading ? <Spinners /> : (<div>
                    <p>Are you sure you would like to delete this PII Data Configuration</p>
                    <div className="btnswrap">
                        <ButtonComponent
                            text="Cancel"
                            className={"cancelBtnStyle btn btn-primary"}
                            onClick={whitelistHide}
                        />
                        <ButtonComponent
                            text="Delete"
                            className={"btnStyle btn btn-primary"}
                            onClick={handleWhitelistedDelete}
                        />
                    </div>
                </div>)}
            </>
        );
    };

    // Regex add/save popup
    const regexAddmodalHide = () => {
        setState((state) => ({
            ...state,
            regexAddBodyOpen: false,
            typeInputState: false,
            expressionInputState: false,
            hierarchyLevelInputState: false,
            addBodyregex: false,
            conformationPop: false,
        }));
        setExpression("");
        setType("");
        setHierarchyLevel("");
    };
    const addmodalCancelDepartment = () => {
        setState((state) => ({
            ...state,
            addBodyregex: true,
        }));
    };
    const addBodyCloseDepartment = () => {
        setState({
            ...state,
            addBodyregex: false,
        });
    };
    const addBodyCancelDepartment = () => {
        return (
            <>
                <DiscardChanges title={'add'} discardClick={regexAddmodalHide} cancelClick={addBodyCloseDepartment} />
            </>
        );
    };
    const addmodalCancelWhitelist = () => {
        setState((state) => ({
            ...state,
            addBodywhitelist: true,
        }));
    };
    const addBodyCloseWhitelist = () => {
        setState({
            ...state,
            addBodywhitelist: false,
        });
        setExpression("");
        setType("");
        setHierarchyLevel("");
    };
    const addBodyCancelWhitelist = () => {
        return (
            <>
                <DiscardChanges title={'add'} discardClick={whitelistAddmodalHide} cancelClick={addBodyCloseWhitelist} />
            </>
        );
    };
    const handleregexSave = () => {
        // Reset error states
        setTypeErrorMessage('');
        setExpressionErrorMessage('');
        setHierarchyLevelErrorMessage('');
        
        // Reset input states
        setState((state) => ({
            ...state,
            typeInputState: false,
            expressionInputState: false,
            hierarchyLevelInputState: false,
        }));

        // Validation flags
        let hasError = false;
        let isTypeDuplicate = false;
        let isExpressionDuplicate = false;
        let isHierarchyLevelDuplicate = false;

        // Check for duplicates
        isTypeDuplicate = regexCustomizationTableData?.data.some(
            (regexData) => regexData.type === type
        );
        isExpressionDuplicate = regexCustomizationTableData?.data.some(
            (regexData) => regexData.expression === expression
        );
        isHierarchyLevelDuplicate = regexCustomizationTableData?.data.some(
            (regexData) => regexData.hierarchyLevel === hierarchyLevel
        );

        const isDuplicateFound = isTypeDuplicate || isExpressionDuplicate || isHierarchyLevelDuplicate;

        // Validate Type
        if (type.trim() === '') {
            setTypeErrorMessage('Type cannot be empty');
            setState((state) => ({
                ...state,
                typeInputState: true,
            }));
            hasError = true;
        } else if (isTypeDuplicate) {
            setTypeErrorMessage('Type already exists');
            setState((state) => ({
                ...state,
                typeInputState: true,
            }));
            hasError = true;
        }

        // Validate Expression
        if (expression.trim() === '') {
            setExpressionErrorMessage('Expression cannot be empty');
            setState((state) => ({
                ...state,
                expressionInputState: true,
            }));
            hasError = true;
        } else if (isExpressionDuplicate) {
            setExpressionErrorMessage('Expression already exists');
            setState((state) => ({
                ...state,
                expressionInputState: true,
            }));
            hasError = true;
        }

        // Validate Hierarchy Level
        if (hierarchyLevel.trim() === '') {
            setHierarchyLevelErrorMessage('Hierarchy Level cannot be empty');
            setState((state) => ({
                ...state,
                hierarchyLevelInputState: true,
            }));
            hasError = true;
        } else if (!/^[1-9]\d*$/.test(hierarchyLevel)) {
            setHierarchyLevelErrorMessage('The Hierarchy level accepts positive values only');
            setState((state) => ({
                ...state,
                hierarchyLevelInputState: true,
            }));
            hasError = true;
        } else if (isHierarchyLevelDuplicate) {
            setHierarchyLevelErrorMessage('Hierarchy Level already exists');
            setState((state) => ({
                ...state,
                hierarchyLevelInputState: true,
            }));
            hasError = true;
        }

        // Only call API if no validation errors
        if (!hasError) {
            props.handleregexSave(type, expression, hierarchyLevel, isDuplicateFound);
            setState((state) => ({
                ...state,
                regexAddBodyOpen: isDuplicateFound ? true : false,
            }));
        } else {
            // If there are errors, set duplicate state but don't call API
            setIsDuplicateAdded(isDuplicateFound);
        }
    };

    const handleTypeChange = (e) => {
        setType(e.target.value);
        setState((state) => ({
            ...state,
            typeInputState: false,
            conformationPop: true,
        }));
    };

    const handleExpressionChange = (e) => {
        setExpression(e.target.value);
        setState((state) => ({
            ...state,
            expressionInputState: false,
            conformationPop: true,
        }));
    };
    const handlehierarchyLevelChange = (e) => {
        setHierarchyLevel(e.target.value);
        setState((state) => ({
            ...state,
            hierarchyLevelInputState: false,
            conformationPop: true,
        }));
    };
    const handleKeyPress = (e) => {
        const char = e.key;

        // Allow only digits 1-9 (block 0, letters, symbols, etc.)
        if (!/^[1-9]$/.test(char)) {
            e.preventDefault();
        }
    };


    const regexAddBody = () => {
        return (
            <>
                <h4>Regex Customization</h4>
                {RegexSaveLoading ? <Spinners /> : (<div>
                    <div>
                        <Input
                            type={""}
                            label="Type*"
                            onChange={handleTypeChange}
                            name="Type"
                            value={type}
                            error={state.typeInputState}
                            errorMessage={typeerrorMessage}
                            placeholder="Eg: Aadhar"
                            autoComplete={"off"}
                            containerClassName={"regexInput frmgroup validate default-input"}
                        />
                    </div>
                    <div>
                        <Input
                            type={""}
                            label="Expression*"
                            name="Expression"
                            value={expression}
                            error={state.expressionInputState}
                            errorMessage={expressionerrorMessage}
                            placeholder="^\d{4}\s?\d{4}\s?\d{4}$"
                            autoComplete={"off"}
                            onChange={handleExpressionChange}
                            containerClassName={"frmgroup validate default-input"}
                        />
                    </div>
                    <div>
                        <Input
                            type={"number"}
                            label="Hierarchy Level*"
                            name="HierarchyLevel"
                            value={hierarchyLevel}
                            error={state.hierarchyLevelInputState}
                            errorMessage={hierarchyLevelerrorMessage}
                            placeholder="eg: 1"
                            autoComplete={"off"}
                            onChange={handlehierarchyLevelChange}
                            containerClassName={"frmgroup validate default-input"}
                            onKeyPress={handleKeyPress}
                        />
                    </div>
                    <div className="d-flex justify-content-end">
                        <ButtonComponent
                            text="Cancel"
                            className={"cancelBtnStyle btn btn-primary"}
                            onClick={() => {
                                if (state.conformationPop) {
                                    addmodalCancelDepartment();
                                } else {
                                    regexAddmodalHide();
                                }
                            }}
                        />
                        <ButtonComponent
                            text="Save"
                            className={"btnStyle btn btn-primary"}
                            onClick={handleregexSave}
                        />
                    </div>
                </div>)}
            </>
        );
    };

    // Whitelist add/save popup
    const whitelistAddmodalHide = () => {
        setState((state) => ({
            ...state,
            whitelistAddBodyOpen: false,
            dataInputState: false,
            addBodywhitelist: false,
            conformationPop: false,
        }));
        setData("");
        setExpression("");
        setType("");
        setHierarchyLevel("");
    };

    const handlewhitelistSave = () => {
        if (data.trim() === '') {
            setDataErrorMessage('Data cannot be empty');
            setState((state) => ({
                ...state,
                dataInputState: true,
            }));
            return;
        }
        if (data.trim() !== '') {
            props.handleWhitelistSave(data);
            setState((state) => ({
                ...state,
                whitelistAddBodyOpen: false,
            }));
            setData("");
        }
    };

    const handleDataChange = (e) => {
        setData(e.target.value);
        setState((state) => ({
            ...state,
            dataInputState: false,
            conformationPop: true,
        }));
    };

    const whitelistAddBody = () => {
        return (
            <>
                <h4>PII Data: Whitelisted</h4>
                {WhiteListSaveLoading ? <Spinners /> : (<div>
                    <div>
                        <Input
                            type={""}
                            label="Data*"
                            name="Data"
                            placeholder="password"
                            autoComplete={"off"}
                            error={state.dataInputState}
                            errorMessage={dataerrorMessage}
                            onChange={handleDataChange}
                            containerClassName={"regexInput frmgroup validate default-input"}
                        />
                    </div>
                    <div className="d-flex justify-content-end">
                        <ButtonComponent
                            text="Cancel"
                            className={"cancelBtnStyle btn btn-primary"}
                            onClick={() => {
                                if (state.conformationPop) {
                                    addmodalCancelWhitelist();
                                } else {
                                    whitelistAddmodalHide();
                                }
                            }
                            }
                        />
                        <ButtonComponent
                            text="Save"
                            className={"btnStyle btn btn-primary"}
                            onClick={handlewhitelistSave}
                        />
                    </div>
                </div>)}
            </>
        );
    };

    return (
        <>
            <div>
                {tableData.map((table) => (
                    <div key={table.key}>
                        <ChartContainer
                            title={table.title}
                            navContainerClass={table.navContainerClass}
                            chartContainerClass={table.chartContainerClass}
                            customClass={table.customClass}
                            chart={table.chart}
                        />
                    </div>
                ))}
            </div>

            {/* Regex delete confirmation popup */}
            <CustomModal
                modalOpen={state.regexmodalOpen}
                modalBody={renderModalBody}
                modalHide={modalHide}
            />

            {/* Regex add popup*/}
            <CustomModal
                modalOpen={state.regexAddBodyOpen}
                modalBody={regexAddBody}
                modalHide={regexAddmodalHide}
                closeBtn={true}
                closeBtnFuc={regexAddmodalHide}
            />

            {/* Whitelisted delete confirmation popup */}
            <CustomModal
                modalOpen={state.whitelistmodalOpen}
                modalBody={whitelistBody}
                modalHide={whitelistHide}
            />

            {/* Whitelisted add popup*/}
            <CustomModal
                modalOpen={state.whitelistAddBodyOpen}
                modalBody={whitelistAddBody}
                modalHide={whitelistAddmodalHide}
                closeBtn={true}
                closeBtnFuc={whitelistAddmodalHide}
            />
            <CustomModal
                modalOpen={state.addBodyregex}
                modalBody={addBodyCancelDepartment}
                modalHide={addBodyCloseDepartment}
                closeBtn={true}
                closeBtnFuc={addBodyCloseDepartment}
            />
            <CustomModal
                modalOpen={state.addBodywhitelist}
                modalBody={addBodyCancelWhitelist}
                modalHide={addBodyCloseWhitelist}
                closeBtn={true}
                closeBtnFuc={addBodyCloseWhitelist}
            />
        </>
    );
};

const columnPropTypes = {
    Header: PropTypes.string.isRequired,
    accessor: PropTypes.string.isRequired,
    Cell: PropTypes.func,
};

const piiColumnPropTypes = PropTypes.shape({
    ...columnPropTypes,
    Cell: PropTypes.func.isRequired,
});

PIIConfigComponent.propTypes = {
    data: PropTypes.shape({
        regexPageLimit: PropTypes.number,
        regexPageNo: PropTypes.number,
        PIIPageLimit: PropTypes.number,
        PIIPageNo: PropTypes.number,
    }),
    row: PropTypes.shape({
        original: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }).isRequired,
    }),
    piiColumns: PropTypes.arrayOf(piiColumnPropTypes).isRequired,
    changeRegexStatus: PropTypes.func.isRequired,
    changeWhitelistStatus: PropTypes.func.isRequired,
    regexCustomizationTableData: PropTypes.array.isRequired,
    regexCustomizationDataCount: PropTypes.number,
    rCTableLoading: PropTypes.bool,
    rCTableCountLoading: PropTypes.bool,
    WhitelistedTableData: PropTypes.arrayOf(PropTypes.object),
    WhitelistedTableCount: PropTypes.number,
    WhitelistedLoading: PropTypes.bool,
    WhitelistedTableCountLoading: PropTypes.bool,
    WhiteListSaveLoading: PropTypes.bool,
    RegexStatusLoading: PropTypes.bool,
    RegexDeleteLoading: PropTypes.bool,
    handleWhitelistSave: PropTypes.func,
    handleregexSave: PropTypes.func,
    handleWhitelistedDelete: PropTypes.func,
    handleRegexDelete: PropTypes.func,
    handlePIIPageChange: PropTypes.func,
    handlePIISearch: PropTypes.func,
    handlePIIPageLimitChange: PropTypes.func,
    handleRegexPageChange: PropTypes.func,
    handleRegexSearch: PropTypes.func,
    handleRegexPageLimitChange: PropTypes.func,
};

export default PIIConfigComponent;